<template>
  <div>
    <!-- pagination: start -->
    <span class="isolate inline-flex rounded-md shadow-sm mt-5">
      <Link
        :href="paginationUrl('first')"
        as="button"
        :disabled="currentPage == 1"
        class="
          relative
          inline-flex
          items-center
          rounded-l-md
          border border-gray-300
          bg-white
          px-2
          py-1
          text-sm
          font-medium
        "
        :class="currentPage == 1 ? 'text-gray-300' : 'text-gray-700 hover:bg-gray-50 focus:z-10 focus:border-markencode-blue focus:outline-none focus:ring-1 focus:ring-markencode-blue'"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="w-4 h-4"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M18.75 19.5l-7.5-7.5 7.5-7.5m-6 15L5.25 12l7.5-7.5"
          />
        </svg>
      </Link>

      <Link
        :href="paginationUrl('prev')"
        as="button"
        :disabled="currentPage == 1"
        class="
          relative
          -ml-px
          inline-flex
          items-center
          border border-gray-300
          bg-white
          px-2
          py-1
          text-sm
          font-medium
        "
        :class="currentPage == 1 ? 'text-gray-300' : 'text-gray-700 hover:bg-gray-50 focus:z-10 focus:border-markencode-blue focus:outline-none focus:ring-1 focus:ring-markencode-blue'"
      >
        <!-- Heroicon name: mini/chevron-left -->
        <svg
          class="h-5 w-5"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
        >
          <path
            fill-rule="evenodd"
            d="M12.79 5.23a.75.75 0 01-.02 1.06L8.832 10l3.938 3.71a.75.75 0 11-1.04 1.08l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 011.06.02z"
            clip-rule="evenodd"
          />
        </svg>
      </Link>

      <Link
        :href="paginationUrl('next')"
        as="button"
        :disabled="currentPage == lastPage"
        class="
          relative
          -ml-px
          inline-flex
          items-center
          border border-gray-300
          bg-white
          px-2
          py-1
          text-sm
          font-medium
        "
        :class="currentPage == lastPage ? 'text-gray-300' : 'text-gray-700 hover:bg-gray-50 focus:z-10 focus:border-markencode-blue focus:outline-none focus:ring-1 focus:ring-markencode-blue'"
      >
        <!-- Heroicon name: mini/chevron-right -->
        <svg
          class="h-5 w-5"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
        >
          <path
            fill-rule="evenodd"
            d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z"
            clip-rule="evenodd"
          />
        </svg>
      </Link>

      <Link
        :href="paginationUrl('last')"
        as="button"
        :disabled="currentPage == lastPage"
        class="
          relative
          -ml-px
          inline-flex
          items-center
          rounded-r-md
          border border-gray-300
          bg-white
          px-2
          py-1
          text-sm
          font-medium
        "
        :class="currentPage == lastPage ? 'text-gray-300' : 'text-gray-700 hover:bg-gray-50 focus:z-10 focus:border-markencode-blue focus:outline-none focus:ring-1 focus:ring-markencode-blue'"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="w-4 h-4"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M11.25 4.5l7.5 7.5-7.5 7.5m-6-15l7.5 7.5-7.5 7.5"
          />
        </svg>
      </Link>
    </span>
    <!-- pagination: end -->
  </div>
</template>

<script>
export default {
  props: {
    queryParams: {
      type: Object,
      required: false,
      default: () => {
        return {};
      },
    },

    currentPage: {
      type: Number,
      required: false,
      default: 1,
    },

    lastPage: {
      type: Number,
      required: true,
    },

    routeName: {
      type: String,
      required: true,
    },

    routeParams: {
      type: Object,
      required: false,
      default: () => {
        return {};
      },
    },
  },

  methods: {
    paginationUrl(page) {
      if (page == 'first') {
        return route(this.routeName, {
          ...this.routeParams,
          ...this.queryParams,
          page: 1,
        });
      }

      if (page == 'prev') {
        return route(this.routeName, {
          ...this.routeParams,
          ...this.queryParams,
          page: this.currentPage > 1 ? this.currentPage - 1 : 1,
        });
      }

      if (page == 'next') {
        return route(this.routeName, {
          ...this.routeParams,
          ...this.queryParams,
          page:
            this.currentPage < this.lastPage
              ? this.currentPage + 1
              : this.lastPage,
        });
      }

      if (page == 'last') {
        return route(this.routeName, {
          ...this.routeParams,
          ...this.queryParams,
          page: this.lastPage,
        });
      }
    },
  },
};
</script>